import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import {
  DisputeCategory,
  DisputeReason,
} from '@arc/unified-payments-frontend/shared-payment';
import { DisputeActions } from '../actions';

export interface DisputeState {
  disputeReasons?: DisputeReason[];
  disputeCategories?: DisputeCategory[];
}

const initialState: DisputeState = {};

export const disputeReducers = createReducer(
  initialState,
  on(
    DisputeActions.GetDisputeCategoriesCompleteAction,
    (state, action): DisputeState => ({
      ...state,
      disputeCategories: action.payload,
    }),
  ),
  on(
    DisputeActions.GetDisputeReasonsCompleteAction,
    (state, action): DisputeState => ({
      ...state,
      disputeReasons: action.payload,
    }),
  ),
);

export const DisputeStore = createFeatureSelector<DisputeState>('dispute');

export const disputeCategoriesMap = (state: DisputeState): DisputeCategory[] =>
  state.disputeCategories;

export const disputeReasonsMap = (state: DisputeState): DisputeReason[] =>
  state.disputeReasons;

export const DisputeCategoriesStore = createSelector(
  DisputeStore,
  disputeCategoriesMap,
);

export const DisputeReasonsStore = createSelector(
  DisputeStore,
  disputeReasonsMap,
);
